/**
 * Copyright (C) 2013-2018 MNEMOTIX <http://www.mnemotix.com/> and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @param error {any} - Error object as returned by an apollo hook (useQuery, useMutation)
 * @param strategy {'log'|'throwError'} - 'log': logs the error to the console
 *                                        'throwError' (default) : logs the error to the console, then throw a new Error, in order to be catched
 *                                                       by a react error boundary component higher up in the react tree
 */
export function apolloErrorHandler(error, strategy = 'throwError') {
  if (error) {
    let stack = new Error("Apollo error catched").stack;
    console.error(stack);
    console.error('Apollo query returned the following error', Object.assign({}, error));

    if (strategy === 'throwError') {
      throw new Error('Apollo error occured');
    }
  }
}
